/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_RoleInputs */



/**
* | output |
* | --- |
* | "ROLE" |
*
* @param {Ccsl_Export_Header_RoleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_role = /** @type {((inputs?: Ccsl_Export_Header_RoleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_RoleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ROLE")
	if (locale === "de") return /** @type {LocalizedString} */ ("ROLLE")
	if (locale === "it") return /** @type {LocalizedString} */ ("RUOLO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("РОЛЬ")
	if (locale === "es") return /** @type {LocalizedString} */ ("ROLE")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("角色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("役割")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भूमिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("PAPEL")
	return /** @type {LocalizedString} */ ("ROLE")
});